module.exports = __webpack_public_path__ + "static/media/my.591d1e38.svg";